import { render, staticRenderFns } from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=template&id=be96230c&scoped=true&"
import script from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=script&lang=js&"
export * from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=script&lang=js&"
import style0 from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=style&index=0&id=be96230c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be96230c",
  null
  
)

export default component.exports